import React from "react";

import Footer from "./footer";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";



function CookiePolicy() {
    return (

        // aboutcompany
        <>


            <div className="space80"></div>


            <div className="cookie-policy">
                <div className="space80"></div>
                <div className="hero-area10 ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="title title2  ">

                                    <h1 className="sk-text-color text-center">Cookie Policy</h1>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>



                <div className="space50"></div>
                <div className="service-binifits9 sp0" >
                    <div className="container">
                        <div className="row">

                            <div className="col-lg-12">
                                <div className="hadding7">
                                    <h2 className="h2">Cookie Policy for Dm2Legal.com</h2>

                                    <p className="pd-text">This is the Cookie Policy for Dm2Legal.com, accessible from https://Dm2Legal.com</p>


                                </div>
                                <div className="space20"></div>

                                <h2>What Are Cookies</h2>

                                <p className="pd-text">As is standard practice with most professional websites, this site uses cookies—small files that are downloaded to your computer—to enhance your experience. This page explains what information cookies collect, how we use that information, and why we may need to store these cookies. We will also explain how you can prevent cookies from being stored; however, please note that doing so may affect certain features and functionality of the site.</p>

                                <p className="pd-text">An HTTP cookie is a small piece of data stored on the user's computer by the web browser while browsing a website. Cookies are designed to be a reliable mechanism for websites to remember stateful information or to record the user's browsing activity.</p>

                                <div className="space20"></div>
                                <h2>How We Use Cookies</h2>

                                <p className="pd-text">We use cookies for several reasons, as outlined below. Unfortunately, in most cases, there are no standard industry options for disabling cookies without completely disabling the functionality and features they provide on this site. If you're unsure whether you need cookies, it is recommended that you keep them enabled, as they may be used to provide services you use. </p>

                                <div className="space20"></div>
                                <h2>Disabling Cookies</h2>

                                <p className="pd-text">You can prevent cookies from being set by adjusting your browser settings (refer to your browser's Help section for instructions). However, please note that disabling cookies may affect the functionality of this site and many others you visit. Disabling cookies will often result in the loss of certain features and functionalities on this site. Therefore, it is recommended that you do not disable cookies.</p>

                                <div className="space20"></div>
                                <h2>The Cookies We Set</h2>
                                <div className="space20"></div>
                                <ul>
                                    <li className="pd-text"><i className="fa fa-circle icone"></i> Account-Related Cookies</li>
                                    <div className="space10"></div>
                                    <p className="pd-text">If you create an account with us then we will use cookies for the management of the signup process and general administration. These cookies will usually be deleted when you log out however in some cases they may remain afterwards to remember your site preferences when logged out.                           </p>

                                    <div className="space20"></div>

                                    <li className="pd-text"><i className="fa fa-circle icone"></i> Login related cookies</li>
                                    <div className="space10"></div>
                                    <p className="pd-text">We use cookies to remember when you are logged in, so you don't have to log in every time you visit a new page. These cookies are usually removed or cleared when you log out to ensure that restricted features and areas are accessible only when you are logged in.</p>

                                    <div className="space20"></div>

                                    <li className="pd-text"><i className="fa fa-circle icone"></i> Email Newsletter-Related Cookies</li>
                                    <div className="space10"></div>
                                    <p className="pd-text">This site offers newsletter or email subscription services, and cookies may be used to remember if you are already registered. They may also be used to determine whether certain notifications should be displayed, depending on whether you are subscribed or unsubscribed.</p>

                                    <div className="space20"></div>

                                    <li className="pd-text"><i className="fa fa-circle icone"></i> Order Processing-Related Cookies</li>
                                    <div className="space10"></div>
                                    <p className="pd-text">This site offers e-commerce and payment facilities, and certain cookies are essential to ensure that your order is remembered between pages, allowing us to process it correctly.</p>

                                    <div className="space20"></div>

                                    <li className="pd-text"><i className="fa fa-circle icone"></i> Form-Related Cookies</li>
                                    <div className="space10"></div>
                                    <p className="pd-text">When you submit data through a form, such as those on contact or comment pages, cookies may be set to remember your user details for future correspondence.</p>

                                </ul>


                                <div className="space20"></div>
                                <h2>Third Party Cookies</h2>
                                <p className="pd-text">In some cases, we use cookies provided by trusted third parties.</p>
                                <div className="space10"></div>
                                <ul>
                                    <li className="pd-text"><i className="fa fa-circle icone"></i> We use third-party analytics to track and measure site usage, which helps us continue to create engaging content. These cookies may track information such as how long you spend on the site and which pages you visit, allowing us to understand how we can improve the site for you.</li>


                                </ul>


                                <div className="space20"></div>
                                <h2>Contact</h2>
                                <p className="pd-text">We hope this has clarified things for you. As mentioned earlier, if you're unsure whether you need a particular cookie, it's generally safer to leave cookies enabled, as they may be necessary for certain features on our site.</p>
                                <p className="pd-text">However, if you still need more information, feel free to contact us through one of our preferred contact methods:</p>

                                <div className="space10"></div>
                                <ul>
                                    <li className="pd-text"><i className="fa fa-circle icone"></i> Email: <a href="mailto:accounts@Dm2Legal.com">accounts@Dm2Legal.com</a> </li>


                                </ul>




                            </div>

                        </div>

                    </div>
                </div>


                <div className="space50"></div>





            </div>






            <WhatsAppScrollButton />

            <Footer />

            <CircularScrollProgress />


        </>
    );
}

export default CookiePolicy;